export class SelectItems {
  public value: number;
  public name: String;
  constructor(_value:number, _name:string)
  {
    this.name = _name; 
    this.value = _value;
  }
}
